









































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import BaseComponent from '../../../core/base.component';
import { BaseUser } from '../../../services/shared/auth';
import {
  CompanyDistrictDto,
  CompanyDistrictUpdateDto,
  CompanyDistrictUpdateRefusalDto,
  CompanyDistrictUpdateRefusalReasonDto,
  AmenityDto,
  CompanyDto,
} from '../../../dto';

import AmenityService from '../../../services/amenity.service';
import CompanyService from '../../../services/company.service';
import CompanyDistrictService from '../../../services/company-district.service';

import ApprovalCard from '../../../modules/_components/ApprovalCard.vue';
import BaseCard from '../../_components/BaseCard.vue';
import CompanyDistrictDeliverySpaceList from './CompanyDistrictDeliverySpaceList.vue';
import DeliverySpaceCreate from '../../delivery-space/components/DeliverySpaceCreate.vue';

import { FileAttachmentDto } from '@/services/shared/file-upload';
import FileUploadService from '../../../services/shared/file-upload/file-upload.service';
import { UPLOAD_TYPE } from '../../../services/shared/file-upload/file-upload.service';
import { ATTACHMENT_REASON_TYPE } from '@/services/shared/file-upload';

import toast from '../../../../resources/assets/js/services/toast.js';
import { getStatusColor } from '../../../core/utils/status-color.util';
import { CompanyDistrictMapUpdateDto } from '@/dto';
import { APPROVAL_STATUS } from '@/services/shared';

@Component({
  name: 'ComapanyDistrictDetail',
  components: {
    ApprovalCard,
    BaseCard,
    CompanyDistrictDeliverySpaceList,
    DeliverySpaceCreate,
  },
})
export default class CompanyDistrictDetail extends BaseComponent {
  private companyDistrictDto = new CompanyDistrictDto();
  private companyDistrictUpdateDto = new CompanyDistrictUpdateDto();
  private companyDistrictUpdateRefusalDto = new CompanyDistrictUpdateRefusalDto();
  private companyDistrictUpdateRefusalReasonDto = (this.companyDistrictUpdateRefusalDto.refusalReasons = new CompanyDistrictUpdateRefusalReasonDto());
  private companyDistrictMapUpdateDto = new CompanyDistrictMapUpdateDto();
  private amenityList = [];
  private companySelect: CompanyDto[] = [];
  private selectedAmenities: AmenityDto[] = [];
  private selectedAmenityIds: number[] = [];

  private addressData = {
    address: null,
  };
  private imageChanged = false;
  private newImage: FileAttachmentDto[] = [];

  // get status color
  getStatusColor(status: APPROVAL_STATUS) {
    return getStatusColor(status);
  }

  // find district detail
  findOne(id) {
    CompanyDistrictService.findOne(id).subscribe(res => {
      this.companyDistrictDto = res.data;
      this.setMap(this.companyDistrictDto);
    });
  }

  // show district update modal
  showUpdateModal() {
    this.getAmenities();
    this.getCompanies();
    this.companyDistrictUpdateDto = this.companyDistrictDto;
    this.addressData.address = this.companyDistrictDto.address;
    this.selectedAmenityIds = this.companyDistrictDto.amenities.map(v => v.no);
    this.findOne(this.$route.params.id);
  }

  // upload disrict image
  async upload(file: File) {
    const attachments = await FileUploadService.upload(
      UPLOAD_TYPE.COMPANY_DISTRICT,
      [file],
    );
    this.newImage = [];
    this.newImage.push(
      ...attachments.filter(
        fileUpload =>
          fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
      ),
    );
    this.imageChanged = true;
  }

  // delete district
  deleteOne() {
    CompanyDistrictService.deleteOne(this.$route.params.id).subscribe(res => {
      if (res) {
        this.$router.push('/company/company-district');
        toast.success('삭제완료');
      }
    });
  }

  // remove district image
  removeDistrictImage() {
    this.$refs['fileInput'].reset();
    this.imageChanged = false;
  }

  // 공용 시설 정보 리스트
  getAmenities() {
    AmenityService.findAmenities('common-facility').subscribe(res => {
      this.amenityList = res.data;
    });
  }

  // 업체 셀렉트 박스
  getCompanies() {
    CompanyService.findForSelect().subscribe(res => {
      this.companySelect = res.data;
    });
  }

  // 지점 정보 수정
  updateCompanyDistrict() {
    if (this.selectedAmenityIds) {
      this.companyDistrictUpdateDto.amenityIds = this.selectedAmenityIds;
    }
    if (this.newImage.length > 0) {
      this.companyDistrictUpdateDto.image = this.newImage;
    }
    if (this.addressData.address) {
      this.companyDistrictUpdateDto.address = this.addressData.address;
    }
    CompanyDistrictService.update(
      this.$route.params.id,
      this.companyDistrictUpdateDto,
    ).subscribe(res => {
      if (res) {
        toast.success('수정완료');
        this.findOne(this.$route.params.id);
      }
    });
  }

  //승인
  updateApproval() {
    CompanyDistrictService.updateCompanyDistrictStatus(
      this.$route.params.id,
      'approve-update',
    ).subscribe(res => {
      if (res) {
        this.findOne(this.$route.params.id);
        toast.success('승인완료');
      }
    });
  }

  // 거절
  updateRefusal() {
    CompanyDistrictService.updateCompanyDistrictStatus(
      this.$route.params.id,
      'refuse-update',
      this.companyDistrictUpdateRefusalDto,
    ).subscribe(res => {
      if (res) {
        this.findOne(this.$route.params.id);
        toast.success('승인거절');
      }
    });
  }

  // clear out disrtrict update dto
  clearOutUpdateDto() {
    this.companyDistrictUpdateDto = new CompanyDistrictUpdateDto();
    this.findOne(this.$route.params.id);
  }

  // 지도 가져오기
  setMap(district: CompanyDistrictDto) {
    const mapContainer = document.getElementById('map'),
      mapOption = {
        center: new window.kakao.maps.LatLng(district.lat, district.lon),
        level: 5,
        maxLevel: 6,
        minLevel: 3,
        mapTypeId: window.kakao.maps.MapTypeId.ROADMAP,
      };

    const map = new window.kakao.maps.Map(mapContainer, mapOption);
    const content = `<span class="badge badge-primary" style="font-size:21px;border-radius: 100px;opacity: 82%">${district.deliverySpaces.length}</span>`;
    const markerPosition = new window.kakao.maps.LatLng(
      district.lat,
      district.lon,
    );

    const customOverlay = new window.kakao.maps.CustomOverlay({
      position: markerPosition,
      content: content,
      // image: markerImage,
    });

    const circle = new window.kakao.maps.Circle({
      map: map,
      center: new window.kakao.maps.LatLng(district.lat, district.lon),
      strokeWeight: 2,
      strokeColor: '#FF00FF',
      strokeOpacity: 0.8,
      strokeStyle: 'dashed',
      fillColor: '#00EEEE',
      fillOpacity: 0.5,
    });
    circle.setRadius(1000);
    circle.setMap(map);
    customOverlay.setMap(map);
  }

  // show address modal
  showAddressModal() {
    this.$bvModal.show('postcode');
  }

  // set address info
  setAddress(res) {
    this.addressData.address = res;

    const geocoder = new window.kakao.maps.services.Geocoder();
    const callback = (results, status) => {
      if (status === window.kakao.maps.services.Status.OK) {
        this.companyDistrictMapUpdateDto.lon = results[0].x;
        this.companyDistrictMapUpdateDto.lat = results[0].y;
        this.companyDistrictMapUpdateDto.region1DepthName =
          results[0].address.region_1depth_name;
        this.companyDistrictMapUpdateDto.region2DepthName =
          results[0].address.region_2depth_name;
        this.companyDistrictMapUpdateDto.region3DepthName =
          results[0].address.region_3depth_name;
        this.companyDistrictMapUpdateDto.hCode = results[0].address.h_code;
        this.companyDistrictMapUpdateDto.bCode = results[0].address.b_code;
      }
      console.log(results);
    };
    geocoder.addressSearch(this.companyDistrictDto.address, callback);
    // this.$bvModal.hide('postcode');
  }

  // show map update modal
  showMapUpdateModal() {
    this.setAddress(this.companyDistrictDto.address);
  }

  // update map info
  updateMap() {
    console.log(this.companyDistrictMapUpdateDto);
    CompanyDistrictService.updateMap(
      this.$route.params.id,
      this.companyDistrictMapUpdateDto,
    ).subscribe(res => {
      if (res) {
        this.findOne(this.$route.params.id);
        toast.success('수정완료');
      }
    });
  }

  created() {
    const id = this.$route.params.id;
    this.findOne(id);
  }
}
